export class SignupRequestToSignupRequestDtoConverter {
    static create = () => {
        return new SignupRequestToSignupRequestDtoConverter();
    };
    toModel = (source) => {
        const { signupOrigin, ...rest } = source;
        return rest;
    };
}
